import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';
import { updatePagesWarnings } from 'store/insurance/actions';
import { SHARED_ERROR_AND_WARNING_VALUE_FIELDS } from 'store/insurance/constants';
import { selectPageWarning } from 'store/insurance/selectors';

const { ROUTES } = Insurance;

export const usePageWarning = () => {
  const dispatch = useDispatch();

  const { route } = useRouteMatch({ routes: ROUTES }) ?? {};

  const { message } = useSelector(selectPageWarning(route));

  const onRemove = useCallback(
    () => {
      if (!route) {
        return;
      }

      dispatch(
        updatePagesWarnings({
          [route]: {
            [SHARED_ERROR_AND_WARNING_VALUE_FIELDS.MESSAGE]: '',
            [SHARED_ERROR_AND_WARNING_VALUE_FIELDS.TYPE]: undefined,
          },
        })
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [route]
  );

  return { message, onRemove };
};
